import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { defineComponent, toRefs, h } from '@vue/composition-api';

var IconProps = {
  width: {
    type: [String, Number]
  },
  height: {
    type: [String, Number]
  },
  fill: {
    type: String
  },
  color: {
    type: String,
    "default": ''
  },
  fontSize: {
    type: String,
    "default": ''
  }
};
/**
 * Icon组件
 */

var Icon = defineComponent({
  name: 'm-icon',
  props: _objectSpread2(_objectSpread2({}, IconProps), {}, {
    svg: {
      type: String,
      required: true
    }
  }),
  emits: ['click'],
  setup: function setup(props, context) {
    var propsRef = toRefs(props);
    return function () {
      return h("span", {
        "class": "m-icon",
        "on": {
          "click": function click(e) {
            return context.emit('click', e);
          }
        },
        "style": {
          color: propsRef.color.value,
          fontSize: propsRef.fontSize.value
        },
        "domProps": {
          "innerHTML": propsRef.svg.value
        }
      });
    };
  }
});

export { IconProps, Icon as default };
//# sourceMappingURL=Icon.js.map
